export const FETCH_SUPPLIERS_REQUEST = "FETCH_SUPPLIERS_REQUEST"
export const FETCH_SUPPLIERS_SUCCESS = "FETCH_SUPPLIERS_SUCCESS"
export const FETCH_SUPPLIERS_FAILED = "FETCH_SUPPLIERS_FAILED"